import { render } from "./ProjectDot.vue?vue&type=template&id=011aab56"
import script from "./ProjectDot.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDot.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ProjectDot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "011aab56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('011aab56', __exports__)) {
    api.reload('011aab56', __exports__)
  }
  
  module.hot.accept("./ProjectDot.vue?vue&type=template&id=011aab56", () => {
    api.rerender('011aab56', render)
  })

}


export default __exports__